import { z } from 'zod';
import { DataSourceField, type JSONArray } from '@sisense/sdk-data';
import { HttpClient } from '@sisense/sdk-rest-client';
import { DataSourceFieldWithDescription } from '@/services/data-sources/data-sources-service';

/**
 * Canonical tool description for getDataSourceFields — reusable by any host (sdk-assistant, MCP server, custom integrations).
 * Hosts may append host-specific notes but should not duplicate or contradict this text.
 */
export const getDataSourceFieldsToolDescription = `Get details of a data source's fields — tables, columns, and user-created formulas — as a flat list. Use this metadata to build queries, charts, or dashboards.

NOT the right tool for "explore / show me / view the model" as a visual diagram. That is getModelSchema (interactive model diagram when the host supports it). Only call this tool when you need the column list for a downstream query-building step, never as the default exploration action.`;

/**
 * Schema for getDataSourceFields engine parameters
 */
export const getDataSourceFieldsSchema = z.object({
	dataSourceTitle: z.string().describe('Data source title'),
});

/**
 * Context interface for getDataSourceFieldsEngine
 */
export interface GetDataSourceFieldsContext {
	/**
	 * Tool call ID
	 */
	toolCallId: string;
	httpClient?: HttpClient;
}

/**
 * Result from getDataSourceFieldsEngine (raw data for UI and for building the LLM summary).
 */
export interface DataSourceFieldsResult {
	dataSourceTitle: string;
	fields: DataSourceFieldWithDescription[] | DataSourceField[];
	/** Shared formulas as JSON */
	formulas?: JSONArray;
}
